export const PROGRAM_TYPE = {
    MOVIE: 'movie',
    SERIES: 'series',
    EPISODE: 'episode',
};
